import Joi from 'joi';

export const schema = Joi.object({
  address: Joi.string()
    .min(3)
    .max(150)
    .error(new Error('Dirección es requerida')),
});
